import React from 'react';
import { Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import ScheduleScreen from '../components/ScheduleScreen';
import { useApp } from '../context/AppContext';

const SchedulePage = () => {
  const navigate = useNavigate();
  const { currentUser } = useApp();

  // Redirecionar para a página inicial se não houver usuário logado
  React.useEffect(() => {
    if (!currentUser) {
      navigate('/');
    }
  }, [currentUser, navigate]);

  const handleBack = () => {
    navigate('/menu'); // Navega diretamente para o Menu Principal
  };

  return (
    <Box height="100vh" width="100%" bg="black">
      <ScheduleScreen onBack={handleBack} />
    </Box>
  );
};

export default SchedulePage;
